export default __webpack_public_path__ + "static/media/iPhone_coupon_redeem.abbac7f4.png";